/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Destination_CountryInputs */

const en_reference_field_destination_country = /** @type {(inputs: Reference_Field_Destination_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination country`)
};

/**
* | output |
* | --- |
* | "Destination country" |
*
* @param {Reference_Field_Destination_CountryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_destination_country = /** @type {((inputs?: Reference_Field_Destination_CountryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Destination_CountryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_destination_country(inputs)
});